import {
  getGoodsSupplyCase,
  getStocksInStores,
  getIsOnlineOnly,
  GoodsSupplyCase,
  StoreStockData,
} from 'features/goods-supply';
import { isWebSellable } from 'features/product-info';
import { styled } from 'linaria/react';
import React from 'react';
import { connect } from 'react-redux';
import { RootReducer } from 'store/root-reducer';
import { ConnectedProps } from 'types/utils';
import { OnlineOrderOnlyMessage } from 'features/product-info/components/online-order-only-message';

export type PickedStockData = Pick<
  StoreStockData,
  'storeFullName' | 'stockValue' | 'stockUnit' | 'displaySample'
>;

export type StocksInStoresMappedState = {
  stocks: PickedStockData[];
  supplyCase: GoodsSupplyCase | null;
  isSellable: boolean;
  isOnlineOnly: boolean;
};
export type StocksInStoresProps = ConnectedProps<StocksInStoresMappedState> &
  React.HTMLAttributes<HTMLDivElement>;

export const OnlineOrderOnly: React.FC<StocksInStoresProps> = ({
  stocks,
  supplyCase,
  isSellable,
  isOnlineOnly,
  ...htmlProps
}) => {
  const itHasStocksRecords = stocks.length > 0;

  const itHasEmptyStocksRecords =
    stocks.length > 0 && stocks.findIndex((stock: PickedStockData) => stock.stockValue > 0) === -1;
  const onlineOrderOnlyDisabled =
    itHasEmptyStocksRecords && stocks.findIndex((stock: PickedStockData) => !!stock.displaySample) !== -1;

  let content: React.ReactNode = null;

  if (isSellable) {
    switch (supplyCase) {
      case 'CASE_3':
      case 'CASE_7':
        content = onlineOrderOnlyDisabled ? null : <OnlineOrderOnlyMessage {...htmlProps} />;
        break;
      default:
        if (itHasStocksRecords) {
          content = null;
        }
        if ((isOnlineOnly || itHasEmptyStocksRecords) && !onlineOrderOnlyDisabled) {
          content = <OnlineOrderOnlyMessage {...htmlProps} />;
        }
        break;
    }
  }

  if (!content) {
    return null;
  }

  return (
    <StyledContainer slot="online-order-only" data-qa="pdp-online-order-only">
      {content}
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  padding-bottom: var(--space-250);
`;

const mapStoreToProps = (store: RootReducer): StocksInStoresMappedState => {
  const stocks = getStocksInStores(store);
  const supplyCase = getGoodsSupplyCase(store);
  const isSellable = isWebSellable(store);
  const isOnlineOnly = getIsOnlineOnly(store);

  return {
    stocks,
    supplyCase,
    isSellable,
    isOnlineOnly,
  };
};

export const PdpOnlineOrderOnly = connect(mapStoreToProps)(OnlineOrderOnly);
